/* Storystir — the shelf page's own filter (sections/ss-collection.liquid).
 *
 * Shelf is a row of real links and needs nothing from here. This does the rest, in the page.
 * On a phone the three fields fold behind "Filter & sort", with a badge counting the ones set,
 * so the books start higher up; on a desktop the panel is opened and its summary hidden.
 *   Author   built from the cards on this shelf, sorted by surname, with counts
 *   Occasion the US gift calendar, from the cards' data-occasions (tags occasion:<id>);
 *            only the occasions some book on this shelf carries, in calendar order
 *   Sort     title A–Z (as served), title Z–A, author by surname
 * The state lives in the address (?author=…&occasion=…&sort=…), so a filtered view can be
 * shared, and Back works. A card whose photograph is missing removes itself (ss-card);
 * everything is recounted when that happens.
 */
(function () {
  const root = document.querySelector('[data-ss-collection]');
  if (!root) return;
  const list = root.querySelector('[data-ss-cards]');
  const controls = root.querySelector('[data-ss-filter-controls]');
  if (!list || !controls) return;
  const sel = {
    author: controls.querySelector('[data-ss-filter="author"]'),
    occasion: controls.querySelector('[data-ss-filter="occasion"]'),
    sort: controls.querySelector('[data-ss-filter="sort"]'),
  };
  const occasionWrap = controls.querySelector('[data-ss-filter-occasion-wrap]');
  // US market: the American calendar of giving. Ids are the publish step's tags; this is their order and wording.
  const OCCASIONS = [['christmas', 'Christmas'], ['halloween', 'Halloween'], ['new-baby', 'New baby'], ['graduation', 'Graduation'],
                     ['wedding', 'Wedding & anniversary'], ['valentines', 'Valentine’s Day'], ['mothers-day', 'Mother’s Day'], ['fathers-day', 'Father’s Day']];
  const has = (c, id) => (' ' + (c.dataset.occasions || '') + ' ').includes(' ' + id + ' ');
  const countEl = root.querySelector('[data-ss-count]');
  const none = root.querySelector('[data-ss-none]');
  const clears = root.querySelectorAll('[data-ss-filter-clear]');
  const more = root.querySelector('[data-ss-filter-more]');
  const badge = root.querySelector('[data-ss-filter-badge]');
  const phone = window.matchMedia('(max-width: 749px)');

  const cards = () => Array.from(list.querySelectorAll('[data-ss-card]'));
  const surname = name => { const w = (name || '').trim().split(/\s+/); return (w[w.length - 1] || '').toLowerCase(); };
  const byTitle = (a, b) => a.dataset.title.localeCompare(b.dataset.title, 'en', { sensitivity: 'base' });
  const stripArticle = t => t.replace(/^(the|a|an)\s+/i, '');
  cards().forEach((c, i) => { c.dataset.order = i; });            // the order the shelf was served in

  function buildAuthors() {
    const keep = sel.author.value;
    const tally = new Map();
    cards().forEach(c => { const a = c.dataset.author; if (a) tally.set(a, (tally.get(a) || 0) + 1); });
    const names = Array.from(tally.keys()).sort((a, b) => surname(a).localeCompare(surname(b)) || a.localeCompare(b));
    sel.author.length = 1;
    names.forEach(n => sel.author.add(new Option(n + ' (' + tally.get(n) + ')', n)));
    sel.author.value = tally.has(keep) ? keep : '';
    const keepOccasion = sel.occasion.value;
    sel.occasion.length = 1;
    OCCASIONS.forEach(([id, name]) => {
      const n = cards().filter(c => has(c, id)).length;
      if (n) sel.occasion.add(new Option(name + ' (' + n + ')', id));
    });
    sel.occasion.value = Array.from(sel.occasion.options).some(o => o.value === keepOccasion) ? keepOccasion : '';
    if (occasionWrap) occasionWrap.hidden = sel.occasion.length < 2;     // nothing tagged on this shelf yet
  }

  function apply(push) {
    const author = sel.author.value, occasion = sel.occasion.value, sort = sel.sort.value;
    const all = cards();
    let shown = 0;
    all.forEach(c => {
      const ok = (!author || c.dataset.author === author) && (!occasion || has(c, occasion));
      c.hidden = !ok;
      if (ok) shown++;
    });
    const sorted = all.slice().sort((a, b) => {
      if (sort === 'title-desc') return stripArticle(b.dataset.title).localeCompare(stripArticle(a.dataset.title));
      if (sort === 'author') return surname(a.dataset.author).localeCompare(surname(b.dataset.author)) || byTitle(a, b);
      return a.dataset.order - b.dataset.order;
    });
    sorted.forEach(c => list.appendChild(c));
    watcher.takeRecords();                                        // re-ordering is our own doing, not a card leaving
    if (countEl) countEl.textContent = shown + (shown === 1 ? ' edition' : ' editions') + (shown < all.length ? ' of ' + all.length : '');
    if (none) none.hidden = shown !== 0;
    const active = !!(author || occasion || sort);
    clears.forEach(b => { if (b.closest('[data-ss-filter-controls]')) b.hidden = !active; });
    if (badge) {                                                  // a folded panel still says how many are set
      const n = [author, occasion, sort].filter(Boolean).length;
      badge.textContent = n; badge.hidden = n === 0;
    }
    if (push) {
      const u = new URL(location.href);
      [['author', author], ['occasion', occasion], ['sort', sort]].forEach(([k, v]) => { if (v) u.searchParams.set(k, v); else u.searchParams.delete(k); });
      history.replaceState(null, '', u.pathname + (u.searchParams.toString() ? '?' + u.searchParams.toString() : ''));
    }
  }

  function fromAddress() {
    const q = new URLSearchParams(location.search);
    ['author', 'occasion', 'sort'].forEach(k => {
      const v = q.get(k) || '';
      if (Array.from(sel[k].options).some(o => o.value === v)) sel[k].value = v;
    });
  }

  // a card that removes itself (no photograph yet) changes the counts and the author list
  const watcher = new MutationObserver(muts => { if (muts.some(m => m.removedNodes.length)) { buildAuthors(); apply(false); } });

  buildAuthors();
  fromAddress();
  if (more) {
    more.hidden = false;
    // folded on a phone, open on a desktop where the summary is hidden. Marked up open, so
    // the fields are still reachable if this never runs.
    const fold = () => { more.open = !phone.matches; };
    fold();
    phone.addEventListener ? phone.addEventListener('change', fold) : phone.addListener(fold);
  } else {
    controls.hidden = false;
  }
  apply(false);

  watcher.observe(list, { childList: true });

  Object.values(sel).forEach(s => s.addEventListener('change', () => apply(true)));
  clears.forEach(b => b.addEventListener('click', () => { sel.author.value = sel.occasion.value = sel.sort.value = ''; apply(true); }));
})();
